import { Icon } from '@blueprintjs/core'
import classNames from 'classnames'
import React, { Component, MouseEvent } from 'react'
import { TranslationFunction } from 'react-i18next'

import './sync-indicator.scss'

type Props = {
  fieldName: string
  disabled: boolean
  editText?: string
  overridenText?: string
  translate?: TranslationFunction
  onSyncChange(fieldName: string, newValue: boolean): void
}

export class SyncIndicator extends Component<Props> {
  render() {
    const { disabled, translate = (_: any) => _, editText, overridenText } = this.props
    const syncClassNames = classNames('sync-indicator', {
      'sync-indicator--overriden': !disabled,
    })

    return (
      <span onClick={this.handleUnlockClick} className={syncClassNames}>
        {translate(getText(disabled, editText, overridenText))}&nbsp;<Icon icon={getIcon(disabled)} title={false} />
      </span>
    )
  }

  private handleUnlockClick = (event: MouseEvent<HTMLElement>) => {
    const { fieldName, disabled } = this.props

    event.preventDefault()
    this.props.onSyncChange(fieldName, !disabled)
  }
}

function getIcon(disabled: boolean) {
  return disabled ? 'edit' : 'cross'
}
function getText(disabled: boolean, editText?: string, overridenText?: string): string {
  return disabled ? editText || 'shared.syncControl.edit' : overridenText || 'shared.syncControl.overriden'
}



// WEBPACK FOOTER //
// ./src/modules/forms/sync-indicator.tsx